import React, { useEffect, useState } from "react";
import PopUp from "../../PopUp/PopUp";
import "../../../container/Billing/common/PlanCard/PlanCard.css";
import "../../../container/Billing/Plans/plans.css";
import "./Upgrade.css";
import PlanCard from "../../../container/Billing/common/PlanCard/PlanCard";
import { getPlans } from "../../../services/api/credits.api";
import actions from "../../../container/Billing/store/billing.actions";
export default function Upgrade({ onClose, toggle }) {
  const [plans, setPlans] = useState(null);
  const [selectedPlan, selectPlan] = useState(null);
  const [seats, setSeats] = useState(null);
  useEffect(() => {
    getPlans().then(({ data, statusCode }) => {
      if (statusCode === 200) {
        const plans = data.plans.filter((plan) => plan.planId !== "0");
        setPlans(plans);
      }
    });
  }, []);
  if (!plans) return null;
  return (
    <PopUp onClose={onClose} toggle={toggle}>
      <div
        style={{ width: "max-content", height: "max-content" }}
        id={"plan_tab"}
        className={"upgrade-popup"}
      >
        <div className="title">
          <h1>Move fast ...</h1>
          <p>aa</p>
        </div>
        <div className={"plans_v2_container"}>
          <div className={"top-gradient-line"} />
          {plans.map((plan, i) => (
            <PlanCard
              plan={plan}
              key={i}
              selectPlan={selectPlan}
              subscriptionType={"yearly"}
              organizationCredits={{}}
              setSeats={setSeats}
              seats={1}
              minSeats={1}
              isCurrentSelected={
                selectedPlan ? plan.planId == selectedPlan.planId : true
              }
              selectedPlan={selectedPlan}
            />
          ))}
        </div>
      </div>
    </PopUp>
  );
}
